import React from "react";
import CommitteeFormPage from "../components/committee/CommitteeFormPage";

const CommitteeCreate = () => <CommitteeFormPage mode="create" />;

export default CommitteeCreate;
